import React from "react"

export default function PageNotFound() {

  return (
    <div>
      <h1>404</h1>
      <h2>This page could not be found - broken url</h2>
    </div>
  );
}